const { showToast } = require('@/@core/utils/utils');
// const FileSaver = require('file-saver');

downloadFile = async (that) => {
  const url = that.getAttribute('dataurl');
  let name = that.getAttribute('dataname');
  name = decodeURI(name);
  try {
    const data = await fetch(url)
    const blob = await data.blob()
    const objectUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.setAttribute('href', objectUrl)
    link.setAttribute('download', name)
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (error) {
    showToast('Lỗi tải file: Không tìm thấy file');
  }
}

// async function downloadFile2(that) {
//   const url = that.getAttribute('dataurl');
//   const name = that.getAttribute('dataname');
//   if (url && name) {
//     const data = await fetch(url);
//     const blob = await data.blob();
//     const objectUrl = URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.setAttribute('href', objectUrl);
//     link.setAttribute('download', name);
//     link.style.display = 'none';
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   }
// FileSaver.saveAs(url, name);
// const anchor = document.createElement('a');
// anchor.href = url;
// anchor.target = '_blank';
// anchor.download = name;
// anchor.click();
// anchor.remove();
// }
